import React from 'react';
import { errorImagePath } from '../utils/errors';

export const ErrorPage = () => (
  <div
    style={{
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <img alt="Error" src={errorImagePath()} />
  </div>
);
